import { TrackingManager } from "../../../../../lib/common/js/services/tracking/trackingManager"

export default () => ({
  internalTracker: new TrackingManager(
    window.trackingConfig.enabledTrackingServices,
    pipelineConfig,
  ),

  init() {
    this.store = Alpine.store("data")
  },

  handleButton() {
    this.internalTracker.trackClick({ clickName: "Continue Clicked" })
    this.store.goToLogin()
  },
})
